interface PanelProps {
  title: string;
  subtitle?: string;
  className?: string;
  children: React.ReactNode;
}

/** Einheitliche Karten-Hülle für Berichtseiten (Titel + optionaler Untertitel). */
export function Panel({ title, subtitle, className = '', children }: PanelProps) {
  return (
    <div className={`card ${className}`}>
      <div className="card-header">
        <div>
          <h3 className="card-title">{title}</h3>
          {subtitle && <p className="card-subtitle">{subtitle}</p>}
        </div>
      </div>
      <div className="card-body">{children}</div>
    </div>
  );
}

/** Seitenkopf für Berichte (Eyebrow + Titel + Beschreibung). */
export function ReportHeader({ title, desc }: { title: string; desc: string }) {
  return (
    <div>
      <div className="section-head mb-1.5">
        <span className="section-eyebrow">Bericht</span>
        <div className="section-rule" />
      </div>
      <h2 className="text-xl font-bold tracking-tight text-slate-900 dark:text-slate-100">{title}</h2>
      <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{desc}</p>
    </div>
  );
}
